import { Pipe, PipeTransform } from '@angular/core';
import { Workspace } from '@workspaces/models/workspaces';

@Pipe({
  name: 'workspaceStatus',
  pure: true,
  standalone: true
})
export class WorkspaceStatusPipe implements PipeTransform {
  transform(workspace: Workspace): string {
    if (!workspace) {
      return 'Unavailable';
    }
    if (workspace.is_deleted) {
      return 'Deleted';
    }
    if (workspace.is_archived) {
      return 'Archived';
    }
    if (!workspace.state) {
      return 'Unknown';
    }

    const normalizedStatus = workspace.state.toUpperCase();

    return WorkspaceStatusPipe.workspaceNameMap(normalizedStatus);
  }

  static workspaceNameMap(normalizedStatus?: string) {
    if (!normalizedStatus) {
      return 'Unavailable';
    }

    switch (normalizedStatus) {
      //Named statuses
      case 'ACTIVE':
        return 'Active';
      case 'DRAFTING':
        return 'Drafting';
      case 'IN_REVIEW':
        return 'Review';
      case 'APPROVED':
        return 'Approved';
      case 'FINISHED':
        return 'Finished';

      //Unknown
      default:
        return WorkspaceStatusPipe.transformToReadable(normalizedStatus);
    }
  }

  static transformToReadable(input: string) {
    let result = input.toLowerCase();
    result = result.replace(/_/g, ' ');
    result = result.replace(/\b\w/g, char => char.toUpperCase());
    return result;
  }
}
